import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { Ticket } from './models/ticket.model';

export interface TicketState extends EntityState<Ticket> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'ticket', idKey: 'Id', cache: { ttl: 120000 } })
export class TicketStore extends EntityStore<TicketState> {
  constructor() {
    super();
  }
}
